var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgZap = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor',
    fillRule: "evenodd",
    d: "M11.1504133,14.75 L3,14.75 C2.36412176,14.75 2.01675471,14.0083569 2.42383404,13.5198617 L12.423834,1.5198617 C12.9032737,0.944534062 13.8370991,1.34990047 13.7442084,2.09302605 L12.8495867,9.25 L21,9.25 C21.6358782,9.25 21.9832453,9.99164311 21.576166,10.4801383 L11.576166,22.4801383 C11.0967263,23.0554659 10.1629009,22.6500995 10.2557916,21.9069739 L11.1504133,14.75 Z M4.60128121,13.25 L12,13.25 C12.4511235,13.25 12.8001634,13.6453862 12.7442084,14.0930261 L12.0615045,19.5546571 L19.3987188,10.75 L12,10.75 C11.5488765,10.75 11.1998366,10.3546138 11.2557916,9.90697395 L11.9384955,4.44534288 L4.60128121,13.25 Z"
  }));
};
export default SvgZap;